import constantObject from 'utilities/constantObject';

const FunctionalTestIds = constantObject([
  // GENERAL
  'GENERAL__TITLE',
  'GENERAL__AVATAR_IMAGE',

  // NAVIGATION (TABS)
  'NAVIGATION__HOME_BUTTON',
  'NAVIGATION__OBJECTS_BUTTON',
  'OBJECTS__ROOT_OVERVIEW_BUTTON',
  'OBJECTS__ROOT_FAVORITES_BUTTON',
  'OBJECTS__ROOT_SHARED_BUTTON',
  'OBJECTS__PAGE_FILTER_TOGGLE_BUTTON',
  'OBJECTS__PAGE_FILTER_COLUMN_ADD_BUTTON',
  'OBJECTS__PAGE_CARD_BUTTON',
  'OBJECTS__CARD_FAVORITE_TOGGLE_BUTTON',
  'OBJECTS__PDP_NOTICE_BUTTON',
  'OBJECTS__SOCIAL_USER_START_TRIAL_REQUEST_BUTTON',
  'NAVIGATION__BUZZ_BUTTON',
  'BUZZ__BEE_ICON',
  'BUZZ__BUZZ_MENU_SHOW_MORE_BUTTON',
  'BUZZ__BUZZ_MENU_SHOW_LESS_BUTTON',
  'BUZZ__AUTHOR_MESSAGE_INPUT',
  'BUZZ__AUTHOR_MESSAGE_SUBMIT_BUTTON',
  'BUZZ__TAG_LIST_CARD_BUTTON',
  'BUZZ__MESSAGE_TITLE',
  'BUZZ__MESSAGE_TIMESTAMP',
  'BUZZ__MESSAGE_TEXT',
  'BUZZ__MESSAGE_CONTENT_BUTTON',
  'BUZZ__MESSAGE_REACTION_PICKER_BUTTON',
  'BUZZ__MESSAGE_QUOTE_REPLY_BUTTON',
  'BUZZ__MESSAGE_DELETE_BUTTON',
  'BUZZ__MESSAGE_MORE_ACTIONS_BUTTON',
  'BUZZ__MESSAGE_REACTION_COUNT',
  'BUZZ__CHANNEL_DETAILS_BUTTON',
  'BUZZ__CHANNEL_DETAILS_TITLE',
  'BUZZ__CHANNEL_DETAILS_INFO_BUTTON',
  'BUZZ__CHANNEL_DETAILS_UNPIN_BUTTON',
  'BUZZ__TOPIC_BROWSER_NEW_TOPIC_BUTTON',
  'BUZZ__TOPIC_BROWSER_SEARCH_INPUT',
  'BUZZ__TOPIC_BROWSER_PIN_TOGGLE_BUTTON',
  'BUZZ__TOPIC_CREATOR_SUBMIT_BUTTON',
  'BUZZ__TOPIC_CREATOR_TITLE_INPUT',
  'BUZZ__TOPIC_CREATOR_DESCRIPTION_INPUT',
  'BUZZ__ADD_PEOPLE_CONVERSATION_BUTTON',
  'BUZZ__ADD_DATA_CONVERSATION_BUTTON',
  'BUZZ__OBJECT_CHANNEL_PAGE_BUTTON',
  'BUZZ__OBJECT_CHANNEL_CARD_BUTTON',
  'BUZZ__OBJECT_CHANNEL_APPROVAL_BUTTON',
  'BUZZ__EMBEDDED_CHANNEL_GO_TO_CHANNEL',
  'BUZZ__NEW_HUDDLE_CANCEL',
  'BUZZ__NEW_HUDDLE_CREATE',
  'BUZZ__NEW_HUDDLE_TITLE',
  'BUZZ__NEW_HUDDLE_PUBLIC',
  'BUZZ__NEW_HUDDLE_PRIVATE',

  'NAVIGATION__PEOPLE_BUTTON',
  'NAVIGATION__NOTIFICATIONS_BUTTON',
  'NAVIGATION__SEARCH_BUTTON',
  'SEARCH__SEARCH_INPUT',
  'NAVIGATION__MORE_BUTTON',
  'MORE__FEEDBACK_BUTTON',
  'MORE__DESKTOP_JUMP_BUTTON',
  'MORE__COPYRIGHT',

  'PEOPLE__SEARCH_INPUT',
  'PEOPLE__CARD_PROFILE',
  'PEOPLE__CARD_MOBILE_PHONE',
  'PEOPLE__CARD_WORK_PHONE',
  'PEOPLE__CARD_BUZZ',
  'PEOPLE__CARD_EMAIL',
]);

export default FunctionalTestIds;
